module.exports = __webpack_public_path__ + "img/login2.e2724d3f.svg";